import { runAfterInitialRender } from 'owa-delayed-initialization';
import subscribeToHierarchyNotification from './notifications/subscribeToHierarchyNotification';

// Import orchestrators so they get registered
import './orchestrators/getFolderDataOrchestrator';

runAfterInitialRender(() => {
    subscribeToHierarchyNotification();
});
